
import WorldCupComponent from "@/libs/WorldCupComponent";
import {Duct} from "@/libs/Duct";
import Defer from "@/libs/Defer";

export default class WhereToWatch
  extends WorldCupComponent
{
  config: any;
  whereToWatch: any;
  isPreloaded: boolean;
  isMounted: boolean;
  defer: Defer;

  created() {
    Duct.open(Duct.Vanes.OnPreloadDone, this.onPreloadDone);

    this.defer = Defer.create().setDeferrable(this);
    this.defer.wait();
  }

  mounted() {
    this.isMounted = true;
    this.onDebug(this, "WhereToWatch:mounted", {});
  }

  onDefer() {
    if (this.isPreloaded && this.isMounted) {
      return false;
    }
    return true;
  }

  onReady() {
  }

  onPreloadDone() {
    this.isPreloaded = true;
  }

}
